export default {
  overview: {
    title: "Machines Overview",
    archive_title: "Archived machines",
    subtitle: "List of all machines.",
    actions: {
      create_new: "Create New Machine",
    },
    search: {
      placeholder: "eg. Name",
    },
    table: {
      headers: {
        id: "ID",
        name: "Name",
        unit: "Unit",
        purchasePrice: "Purchase Price",
        createdAt: "Created at",
      },
      empty: {
        purchasePrice: "Not set",
      },
    },
  },
  // Selling unit of a machine for a customer or in a project (LewMachineSellingUnitSelect).
  selling_unit: {
    label: "Selling unit",
    hint_variable: "A surcharge uses the machine's unit",
    same_as_machine: "Same as machine",
  },
  detail: {
    title: "Machine Details",
    actions: {
      update: "Save",
    },
    tabs: {
      general: "General",
      files: "File storage",
      activity: "Activity",
    },
    form: {
      name: "Name",
      unit: "Billing unit",
      purchasePrice: "Purchase Price",
      purchaseUnit: "Purchase Price Unit",
      note: "Notes",
      sections: {
        base_data: "Master data",
        purchase: "Purchase",
        note: "Note",
      },
    },
  },
  create: {
    title: "Create Machine",
    subtitle: "Create a new Machine.",
  },
  component: {
    autocomplete: {
      noDataText: "Machine not found {value}",
    },
  },
}
